/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { State } from '@core/store';
import * as CustomerActions from '@customers/store/customers.actions';
import { getCustomers, isActionPending } from '@customers/store/customers.selectors';
import { Store } from '@ngrx/store';
import { FilterableDataSource } from '@shared/filterable-data-source';
import { Customer } from '@shared/models';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-customers',
    templateUrl: './customers.component.html',
    styleUrls: ['./customers.component.scss'],
    standalone: false
})
export class CustomersComponent implements OnInit {
  readonly tableColumns = [
    'customerNr',
    'code',
    'street',
    'zipCode',
    'city',
    'phone',
    'email'
  ];
  searchForm: UntypedFormGroup;
  actionPending$: Observable<boolean>;
  customers = new FilterableDataSource<Customer>();

  constructor(
    private store: Store<State>,
    private formBuilder: UntypedFormBuilder
  ) {
    this.searchForm = this.formBuilder.group({
      customerNr: [''],
      code: [''],
      streetName: [''],
      zipCode: [''],
      city: [''],
      phone: [''],
      email: ['']
    });

    this.searchForm.valueChanges.subscribe(
      filterValues => this.customers.setFilter(filterValues)
    );
  }

  ngOnInit(): void {
    this.actionPending$ = this.store.select(isActionPending);
    this.actionPending$.subscribe();
    this.store.select(getCustomers).subscribe(
      customers => this.customers.data = customers
    );
    this.store.dispatch(new CustomerActions.LoadCustomers());
  }
}
